import EnumUtils from "utils/EnumUtils.js";
import Chip from "@mui/material/Chip";

function getStatusChip(formStatusTypeEnum) {
  let color = "success";
  let className = "app-status-badge app-status-success";
  if (formStatusTypeEnum === "NOT_STARTED") {
    color = "error";
    className = "app-status-badge app-status-error";
  } else if (formStatusTypeEnum === "INCOMPLETE") {
    color = "warning";
    className = "app-status-badge app-status-warning";
  }
  return (
    <Chip
      label={EnumUtils.parse(formStatusTypeEnum)}
      color={color}
      size="small"
      className={className}
    />
  );
}

const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
};

const FormUtils = {
  getStatusChip,
  debounce,
};

export default FormUtils;
